import * as filterService from '../../../services/filterService.js';
import {
  PERSONNEL_OBJECT_TYPE_ID,
  NONPERSONNEL_OBJECT_TYPE_ID,
} from '../../../static/constants.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import { FILTER_TYPES } from './filterHelpers.js';
import { ToastComponent } from '@tylertech/forge';

export const getFilterDataByFilterType = async (
  filterType,
  params,
  appliedFilters,
  nameConventions,
  activeBudget,
  organizationBudgets,
) => {
  let result = null;
  switch (filterType) {
    case FILTER_TYPES.COST_BENCHMARK_COST:
      result = filterService.getBenchmarkCostFilters();
      break;
    case FILTER_TYPES.FUND:
      result = await filterService.getFundFilterData(nameConventions);
      break;
    case FILTER_TYPES.DEPARTMENT:
      result = await filterService.getDepartmentFilterData(
        appliedFilters.find((filter) => filter.type === FILTER_TYPES.DIVISION),
        nameConventions
      );
      break;
    case FILTER_TYPES.DIVISION:
      result = await filterService.getDivisionFilterData(
        appliedFilters.find((filter) => filter.type === FILTER_TYPES.DEPARTMENT),
        nameConventions
      );
      break;
    case FILTER_TYPES.BPA:
      result = await filterService.getBPAFilterData(nameConventions);
      break;
    case FILTER_TYPES.QUARTILE:
      result = filterService.getQuartileFilterData();
      break;
    case FILTER_TYPES.COST_TYPE:
      result = filterService.getCostTypeFilterData();
      break;
    case FILTER_TYPES.STATUS:
      result = filterService.getStatusFilterData();
      break;
    case FILTER_TYPES.RESULT:
      result = await filterService.getResultFilterData(nameConventions);
      break;
    case FILTER_TYPES.SERVICE_TYPE:
      result = filterService.getServiceTypeFilterData();
      break;
    case FILTER_TYPES.COMPLEXITY:
      result = await filterService.getComplexityFilterData(params);
      break;
    case FILTER_TYPES.TIMELINE:
      result = await filterService.getTimelineFilterData(params);
      break;
    case FILTER_TYPES.PROGRAM_CHANGE:
      result = await filterService.getProgramChangeFilterData(params);
      break;
    case FILTER_TYPES.ACCOUNT_TYPE:
      result = filterService.getAccountTypeFilterData();
      break;
    case FILTER_TYPES.ACCOUNT_CODE:
      result = await filterService.getAccountCodeFilterData(activeBudget);
      break;
    case FILTER_TYPES.QUESTIONS:
      result = filterService.getQuestionsFilterData();
      break;
    case FILTER_TYPES.DURATION_TYPE:
      result = filterService.getDurationTypeFilterData();
      break;
    case FILTER_TYPES.QUARTILE_DIFF:
      result = filterService.getQuartileDiffs();
      break;
    // case FILTER_TYPES.PERSONNEL:
    //   result = await filterService.getAllocationFilterData(
    //     FILTER_TYPES.COST_ALLOCATION_PERSONNEL,
    //     params
    //   );
    //   break;
    // case FILTER_TYPES.NON_PERSONNEL:
    //   result = await filterService.getAllocationFilterData(
    //     FILTER_TYPES.COST_ALLOCATION_NON_PERSONNEL,
    //     params
    //   );
    //   break;
    // case FILTER_TYPES.REVENUE:
    //   result = await filterService.getAllocationFilterData(
    //     FILTER_TYPES.COST_ALLOCATION_REVENUE,
    //     params
    //   );
    //   break;
    case FILTER_TYPES.COST_ALLOCATION_PERSONNEL:
      result = await filterService.getPersonnelFiltersForCostAllocation(
        FILTER_TYPES.COST_ALLOCATION_PERSONNEL,
        nameConventions
      );
      break;
    case FILTER_TYPES.COST_ALLOCATION_NON_PERSONNEL:
      result = await filterService.getPersonnelFiltersForCostAllocation(
        FILTER_TYPES.COST_ALLOCATION_NON_PERSONNEL,
        nameConventions
      );
      break;
    case FILTER_TYPES.COST_ALLOCATION_REVENUE:
      result = await filterService.getPersonnelFiltersForCostAllocation(
        FILTER_TYPES.COST_ALLOCATION_REVENUE,
        nameConventions
      );
      break;
    // Data Visualization
    case FILTER_TYPES.DV_DIVISION:
      result = await filterService.getDVDivisionsFilterData(
        appliedFilters.find((filter) => filter.type === FILTER_TYPES.DV_SECTION),
        nameConventions
      );
      break;
    case FILTER_TYPES.DV_SECTION:
      result = await filterService.getDVSectionsFilterData(
        appliedFilters.find(
          (filter) => filter.type === FILTER_TYPES.DV_DIVISION
        ),
        nameConventions
      );
      break;
    case FILTER_TYPES.DV_QUARTILE:
      result = filterService.getDVQuartileFilterData();
      break;
    case FILTER_TYPES.DV_PERSONNEL:
      result = await filterService.getDVPersonnelFilterData(nameConventions);
      break;
    case FILTER_TYPES.DV_NONPERSONNEL:
      result = await filterService.getDVNonPersonnelFilterData(nameConventions);
      break;
    case FILTER_TYPES.DV_REVENUE:
      result = await filterService.getDVRevenueFilterData(nameConventions);
      break;
    case FILTER_TYPES.DV_BUDGET:
      result = await filterService.getDVBudgetsFilterData(organizationBudgets, nameConventions);
      break;
    case FILTER_TYPES.DV_RESULT:
      result = await filterService.getResultFilterData(nameConventions);
      break;
    case FILTER_TYPES.DV_FUND:
      result = await filterService.getFundFilterData();
      break;
    // budgeter
    case FILTER_TYPES.REQUEST_STATUS:
      result = filterService.getRequestsStatusTypesData();
      break;
    case FILTER_TYPES.BUDGETER_PERSONNEL:
      result = await filterService.getBudgeterCategoryTypes(PERSONNEL_OBJECT_TYPE_ID, activeBudget, nameConventions);
      break;
    case FILTER_TYPES.BUDGETER_NON_PERSONNEL:
      result = await filterService.getBudgeterCategoryTypes(NONPERSONNEL_OBJECT_TYPE_ID, activeBudget, nameConventions);
      break;
    case FILTER_TYPES.BUDGETER_ORGANIZATION_LEVELS:
      result = await filterService.getOrganizationLevelsForBudgeter(activeBudget, nameConventions);
      break;
    case FILTER_TYPES.BUDGETER_GROUPS_FILTER:
      result = await filterService.getBudgeterGroupsFilterData(activeBudget);
      break;
    case FILTER_TYPES.REQUEST_TYPE:
      result = filterService.getRequestTypeFilterData();
      break;
    case FILTER_TYPES.OFFSET:
      result = filterService.getOffsetFilterData();
      break;
    default:
      ToastComponent.present({
        message: messageManager(nameConventions).MISSING_FILTER_TYPE(filterType),
      });
  }
  return {
    type: filterType,
    options: result.data || result,
    hasSelectAll: Boolean(params && params.hasSelectAll),
    filterType: result.filterType,
    isLinked: result.isLinked || false,
  };
};

